<template>
    <residencies-invite-invoke
        :params="{
            residency: residency.uuid
        }"
        @success="show_invoke_modal = false; show_invoked_modal = true"
        v-slot="{
            is_loading: is_saving,
            error,
            invoke
        }"
    >
        <div>
            <error-modal
                v-if="error"
                :error="error"
                @close="forget"
            />

            <modal-success
                v-else-if="show_invoked_modal"
                :is-open="show_invoked_modal"
                @close="closeAll(); $emit('success')"
            >
                <template slot="heading">Tenant invited</template>

                <p>
                    If you haven't already, you might want to personally let your tenant know that you've invited
                    them to join your tenancy at Rentora - and why.
                </p>

                <div
                    slot="footer"
                    slot-scope="{ close }"
                    class="flex flex-col md:flex-row-reverse"
                >
                    <button
                        type="button"
                        @click.prevent="close"
                        class="text-center btn"
                    >
                        Close
                    </button>
                </div>
            </modal-success>

            <modal-blue
                v-else-if="show_invoke_modal"
                :is-open="show_invoke_modal"
                @close="closeAll"
            >
                <base-form
                    @submit="invoke"
                    slot-scope="{ close }"
                >
                    <div class="px-4 pt-6 border-b sm:px-6">
                        <h6 class="mb-3 text-lg font-normal font-semibold text-center">
                            Invite Tenant
                        </h6>

                        <base-alert
                            v-if="!can_invite"
                            level="danger"
                            class="mb-6"
                        >
                            <template slot="heading">No contact details</template>

                            <template slot="content">
                                <p>You need to add an email or telephone number for this tenant.</p>
                            </template>
                        </base-alert>

                        <div class="mb-6 text-grey-darker">
                            <p class="mb-3">Invite <strong>{{ residency.occupant.name }}</strong> to join this tenancy, so they can:</p>

                            <ul class="pl-5 list-disc">
                                <li>Receive automated reminders for upcoming rent, and be chased for late rents.</li>
                                <li>Pay their rent (and fees) with greater financial flexibility</li>
                                <li>Access shared documents and inventories</li>
                                <li>Exchange messages with you through our logged messaging service</li>
                            </ul>
                        </div>
                    </div>

                    <footer class="flex flex-col px-6 py-3 rounded-b md:flex-row-reverse bg-grey-bg">
                        <base-button
                            :is-loading="is_saving"
                            :disabled="!can_invite"
                            type="submit"
                            class="w-full btn btn-blue md:w-auto"
                        >
                            Send Invitation
                        </base-button>

                        <button
                            type="button"
                            class="text-center btn md:mr-3"
                            @click.prevent="close"
                        >
                            Cancel
                        </button>
                    </footer>
                </base-form>
            </modal-blue>
        </div>
    </residencies-invite-invoke>
</template>

<script>
    import ResidenciesInviteInvoke from '../../../../../../../components/residencies-invite-invoke'

    export default {
        components: {
            ResidenciesInviteInvoke
        },
        model: {
            prop: 'toggled',
            event: 'toggle'
        },
        props: {
            toggled: {
                type: Boolean,
                required: true
            },
            residency: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                show_invoke_modal: this.toggled,
                show_invoked_modal: false
            }
        },
        computed: {
            can_invite () {
                return this.residency.occupant.email || this.residency.occupant.telephone
            }
        },
        watch: {
            toggled () {
                this.show_invoke_modal = this.toggled
            }
        },
        methods: {
            closeAll () {
                this.show_invoke_modal = false
                this.show_invoked_modal = false

                this.$emit('toggle', false)
            },
            onSuccess () {
                this.show_invoke_modal = false
                this.show_invoke_modal = true
            }
        }
    }
</script>
